const getSalaryType = (id: string, items?: IItems[]) => {
  if (items) {
    const result = items.find((v) => v.id === id) ?? items[0];

    return result.text;
  }
};

export default getSalaryType;
